module.exports = __webpack_public_path__ + "static/media/bike-image-01-02.ac72a93c.png";